import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { Prize as UIPrize } from "@jti/loyalty/components/Prize";

import { Placeholder } from "@/components/Placeholder/Placeholder";

import type { prizeInputs } from "./Prize.builder";

type PrizeBuilderProps = BuilderComponentProps<typeof prizeInputs>;

export const Prize: FC<PrizeBuilderProps> = ({
  earnPointsCtaUrl,
  prize_uuid,
  images,
  discoverButtonUrl,
  newOfferDays,
  loginButtonUrl,
  logoUrl,
  logoAlt,
  prizesPageUrl,
  isLotteryAddressRequirementDisabled,
  quantityAriaLabel,
  increaseAriaLabel,
  decreaseAriaLabel,
}) => {
  if (isEditing()) {
    return <Placeholder>Prize component</Placeholder>;
  }
  return (
    <UIPrize
      prize_uuid={prize_uuid}
      images={images}
      newOfferDays={newOfferDays}
      logoAlt={logoAlt}
      logoUrl={logoUrl}
      prizesPageUrl={prizesPageUrl}
      loginButtonUrl={loginButtonUrl}
      earnPointsCtaUrl={earnPointsCtaUrl}
      discoverButtonUrl={discoverButtonUrl}
      isInEditor={isEditing()}
      isLotteryAddressRequirementDisabled={isLotteryAddressRequirementDisabled}
      quantityAriaLabel={quantityAriaLabel}
      increaseAriaLabel={increaseAriaLabel}
      decreaseAriaLabel={decreaseAriaLabel}
    />
  );
};
